import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import { JWTService } from '@/shared/services/jwt'
import download from 'downloadjs'

import AutoTypeRepository from '@/shared/http/repositories/configuration/autotype'
import AutoModelRepository from '@/shared/http/repositories/configuration/automodel'
import BrandRepository from '@/shared/http/repositories/configuration/brand'
import RegulationAutoRepository from '@/shared/http/repositories/regulation/auto/regulationauto.js'

import Datepicker from 'vuejs-datepicker'
import {VMoney} from 'v-money'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'

import SinisterWorkshopReturnModel from '@/shared/models/regulation/auto/sinisterworkshopreturn-model'
import CarInspectionHeader from '@/components/regulation/auto/carinspectionheader/carinspectionheader.vue'

import SinisterRegisterModel from '@/shared/models/regulation/auto/sinisterregistermodel'
import SinisterValues from './values/SinisterValues.vue'
import registerForm from '../register/register-form'

import RegulationWorkshopReturnRepository from '@/shared/http/repositories/regulation/auto/regulationautoworkshopreturn'
import RegulationImageRepository from '@/shared/http/repositories/regulation/auto/regulationautoimage'
import RegulationBudgetRepository from '@/shared/http/repositories/regulation/auto/regulationautobudget'

import ExpertMixin from '@/store/module/expert/mixin.js'
import RegulationMixin from '@/store/module/regulation/mixin'
import StageMixin from '@/store/module/stage/mixin.js'
import SinisterWorkshopReturnForm from './sinisterworkshopreturn-form'

const TAB_INITIALINSPECT = 'VISTORIA_INICIAL'

export default {
  name: 'SinisterWorkshopReturn',
  props: [ 'clear' ],
  directives: {money: VMoney},
  mixins: [
    ActionsForm,
    ExpertMixin,
    StageMixin,
    RegulationMixin
  ],
  data () {
    return {
      imageId: null,
      ImageTypeMnemonic: null,
      files: [],
      data: SinisterWorkshopReturnModel,
      form: SinisterWorkshopReturnForm,
      sinisterData: SinisterRegisterModel,
      en: en,
      es: es,
      ptBR: ptBR,
      album: { titleAlbum: '' },
      images: [],
      budgets: [],
      isShowingAlbums: false,
      isShowingImages: false,
      isShowingImagesCarousel: false,
      slide: 0,
      sliding: null,
      moneyFormat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      STG_FRUSTRATED: false,
      STG_CANCELED: false,
      EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
      qntImagensSend: 0,
      qntImagensReportSend: 0,
      qntImagensSendTotal: 0,
      variantProgressBar: 'primary'
    }
  },
  components: {
    Datepicker,
    SinisterValues,
    AutoTypeRepository,
    AutoModelRepository,
    CarInspectionHeader
  },
  watch: {
    // TODO RETIRAR APÓS REFACTOR
    clear: function () {
      this.onClear()
    }
  },
  mounted () {
    this.ImageTypeMnemonic = TAB_INITIALINSPECT
  },
  created () {
    // document.querySelector("#inputImages").onchange = pullfiles;
  },
  computed: {
    totalBudgeted: function () {
      return (Number(this.form.valueBodywork.value) + Number(this.form.valueTapestry.value) + Number(this.form.valuePainting.value) + Number(this.form.valueGlassware.value) + Number(this.form.valueElectrical.value) + Number(this.form.valueMechanical.value) + Number(this.form.valueThird.value))
    },
    getAllExpert: function () {
      var result = []
      if ((this.experts) && (this.experts.count) > 0) {
        var data = this.experts.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.expertID.options = result
      }
      return result
    },
    getMechanicalWorkshopID: function () {
      var result = null
      var payload = JWTService.GetTokenPayload()
      if (payload != null && payload.MechanicalWorkshopID != null) {
        result = payload.MechanicalWorkshopID
      }
      return result
    },
    getUpdatedSinisterData: function () {
      var returnData = this.sinisterData
      returnData.accountIDUpdate = JWTService.GetTokenPayload().AccountID
      if (this.regulation.autoModelID !== this.EMPTY_GUID) {
        returnData.autoModelID = this.regulation.autoModelID
      } else {
        returnData.autoModelID = null
      }
      if (this.regulation.autoModel.brand.autoTypeID !== this.EMPTY_GUID) {
        returnData.autoTypeID = this.regulation.autoModel.brand.autoTypeID
      } else {
        returnData.autoTypeID = null
      }
      // returnData.autoboard = this.regulation.autoboard
      if (this.regulation.autoModel.brandID !== this.EMPTY_GUID) {
        returnData.brandID = this.regulation.autoModel.brandID
      } else {
        returnData.brandID = null
      }
      returnData.budgetNumber = this.regulation.budgetNumber
      if (this.regulation.budgetSystemID !== this.EMPTY_GUID) {
        returnData.budgetSystemID = this.regulation.budgetSystemID
      } else {
        returnData.budgetSystemID = null
      }
      if (this.regulation.businessTypeID !== this.EMPTY_GUID) {
        returnData.businessTypeID = this.regulation.businessTypeID
      } else {
        returnData.businessTypeID = null
      }
      returnData.chassis = this.regulation.chassis
      returnData.color = this.regulation.color
      if (this.regulation.companyID !== this.EMPTY_GUID) {
        returnData.companyID = this.regulation.companyID
      } else {
        returnData.companyID = null
      }
      if (this.regulation.conductorID !== this.EMPTY_GUID) {
        returnData.conductorID = this.regulation.conductorID
      } else {
        returnData.conductorID = null
      }
      returnData.damageClaimed = this.regulation.damageClaimed
      returnData.dateUpdate = this.regulation.dateUpdate
      returnData.description = this.regulation.description
      returnData.id = this.regulation.id
      if (this.regulation.insuranceID !== this.EMPTY_GUID) {
        returnData.insuranceID = this.regulation.insuranceID
      } else {
        returnData.insuranceID = null
      }
      if (this.regulation.insuredID !== this.EMPTY_GUID) {
        returnData.insuredID = this.regulation.insuredID
      } else {
        returnData.insuredID = null
      }
      returnData.mechanicalWorkshopID = this.getMechanicalWorkshopID
      returnData.plate = this.regulation.plate
      returnData.receiptDate = this.regulation.receiptDate
      if (this.regulation.regulationTypeID !== this.EMPTY_GUID) {
        returnData.regulationTypeID = this.regulation.regulationTypeID
      } else {
        returnData.regulationTypeID = null
      }
      if (this.regulation.responsibleID !== this.EMPTY_GUID) {
        returnData.responsibleID = this.regulation.responsibleID
      } else {
        returnData.responsibleID = null
      }
      if (this.regulation.schedulingTypeID !== this.EMPTY_GUID) {
        returnData.schedulingTypeID = this.regulation.schedulingTypeID
      } else {
        returnData.schedulingTypeID = null
      }
      returnData.seem = this.regulation.seem
      returnData.sinisterCode = this.regulation.sinisterCode
      returnData.sinisterDate = this.regulation.sinisterDate
      returnData.sinisterVersion = this.regulation.sinisterVersion
      if (this.regulation.stageID !== this.EMPTY_GUID) {
        returnData.stageID = this.regulation.stageID
      } else {
        returnData.stageID = null
      }
      if (this.regulation.thirdID !== this.EMPTY_GUID) {
        returnData.thirdID = this.regulation.thirdID
      } else {
        returnData.thirdID = null
      }
      returnData.year = this.regulation.year
      return returnData
    },
    getAtRegulationStage: function () {
      var allStages = this.stages.data
      var returnValue = {}
      for (var stg in allStages) {
        if (allStages[stg].mnemonic === 'CONST_INBUDGETING') {
          returnValue = allStages[stg]
        }
      }
      return returnValue
    },
    getQntImageSend () {
      return 'Upload de imagem (' + this.qntImagensReportSend + ' de ' + this.qntImagensSendTotal + ')...'
    }
  },
  methods: {
    async onUploadNew () {
      if (this.regulation) {
        this.openModalSendImages()
        const files = this.$refs.files.files
        if (files && files.length > 0) {
          this.qntImagensSendTotal = files.length
          let response
          try {
            for (var i = 0; i < files.length; i++) {
              let formData = new FormData()
              if (files[i].name.toUpperCase().includes('.PNG') || files[i].name.toUpperCase().includes('.JPG') || files[i].name.toUpperCase().includes('.JPEG')) {
                if ((files[i].size / 1024) > 500) {
                  try {
                    const compressedFile = await this.compressImage(files[i], {
                      quality: 0.75,
                      type: 'image/jpeg'
                    })
                    formData.append('files[0]', compressedFile)
                  } catch (e) {
                    formData.append('files[0]', files[i])
                  }
                } else {
                  formData.append('files[0]', files[i])
                }
              } else {
                formData.append('files[0]', files[i])
              }
              this.qntImagensReportSend = i + 1
              this.atualizarPercentagemUploadImagem(i + 1, files.length)
              response = await RegulationImageRepository.Upload(this.regulation.id, this.ImageTypeMnemonic, formData)
            }
          } catch (err) {
            this.onException(err)
            this.variantProgressBar = 'danger'
            this.atualizarPercentagemUploadImagem(files.length, files.length)
            await setTimeout(() => {}, 2000)
          }
          this.onGetImageByMnemonic()
          this.onResult(response)
          this.closeModalSendImages()
        } else {
          this.closeModalSendImages()
        }
      }
    },
    onUpload () {
      if (this.regulation) {
        loading.push()
        const files = this.$refs.files.files
        if (files && files.length > 0) {
          let formData = new FormData()
          for (var i = 0; i < files.length; i++) {
            formData.append('files[' + i + ']', files[i])
          }
          RegulationImageRepository.Upload(this.regulation.id, this.ImageTypeMnemonic, formData)
            .then((response) => {
              this.onGetImageByMnemonic()
              this.onResult(response)
              loading.close()
            })
            .catch((err) => {
              this.onException(err)
            })
        } else {
          loading.close()
        }
      }
    },
    getPath (path, fileName) {
      return process.env.FileStorageURL + path + '/' + fileName
    },
    setTabName (name) {
      this.ImageTypeMnemonic = name
      this.onGetImageByMnemonic()
    },
    onRequestQuote () {
      if (this.regulation.stage.mnemonic === 'CONST_REGISTERED' && this.images.length > 0) {
        this.$refs['modal-confirm-on-request-quote'].show()
      } else if (this.regulation.stage.mnemonic === 'CONST_REGISTERED' && this.images.length === 0) {
        toast.error(this.$lang.Common.NoRegulationImages)
      }
    },
    onRequestQuoteModalClose () {
      this.$refs['modal-confirm-on-request-quote'].hide()
    },
    onRequestQuoteModalYes () {
      this.$refs['modal-confirm-on-request-quote'].hide()
      var initStage = this.getAtRegulationStage
      registerForm.stageID.value = initStage.id
      this.onUpdateRegulation()
    },
    onGetImageByMnemonic () {
      this.images = []
      RegulationImageRepository.GetImageByMnemonic(this.regulation.id, this.ImageTypeMnemonic)
        .then((response) => {
          this.images = response.data.data
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    LoadBudgets () {
      this.budgets = []
      RegulationBudgetRepository.GetAll(this.regulation.id)
        .then((response) => {
          this.budgets = response.data.data
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
    onClear () {
      var self = this
      Tools.SetFormDefaultValues(self.form)
      // TODO PADRONIZAR LIMPEZA DOS FORMS DA TELA DE SINISTRO
      setTimeout(() => {
        if (!!this.regulation && !!this.regulation.id) {
          self.form.regulationAutoID.value = this.regulation.id
        }
        if (self.data.id && self.data.id !== '00000000-0000-0000-0000-000000000000') {
          self.form.id.value = self.data.id
        }
      }, 1000)
    },
    onSave () {
      var self = this
      this.form.regulationAutoID.value = this.regulation.id
      if (Tools.ValidateForms(this.form, this.data, self)) {
        // Set default data
        this.data.dateUpdate = this.moment().format('YYYY-MM-DD hh:mm:ss')
        this.data.accountIDUpdate = JWTService.GetTokenPayload().AccountID
        if (this.data.hasOwnProperty('companyID')) {
          this.data.companyID = JWTService.GetTokenPayload().companyID
        }

        if (this.data) {
          if (this.data.id !== null && this.data.id !== '00000000-0000-0000-0000-000000000000') {
            this.onUpdate()
          } else {
            this.data.id = '00000000-0000-0000-0000-000000000000'
            this.data.status = 1
            this.onCreate()
          }
        } else {
          toast.error(this.$lang.Common.NoRecordInformed)
        }
      }
    },
    onCreate () {
      loading.push()
      RegulationWorkshopReturnRepository.Create(this.data)
        .then((response) => {
          var result = this.onResultObj(response)
          if (result !== null) {
            this.form.id.value = result.id
          }
          this.onResult(response, true, true)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      RegulationWorkshopReturnRepository.Update(this.data)
        .then((response) => {
          this.onResult(response, true, true)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdateRegulation () {
      loading.push()
      var sinisterData = this.getUpdatedSinisterData
      var regulationStage = this.getAtRegulationStage
      sinisterData.stageID = regulationStage.id
      RegulationAutoRepository.Update(sinisterData)
        .then((response) => {
          this.regulation.stageID = regulationStage.id
          this.regulation.stage = regulationStage
          this.onResult(response, true, true)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoad (regulation) {
      if (regulation) {
        this.regulation = regulation
        // this.onEdit()
        this.onGetImageByMnemonic()
      }
    },
    onEdit () {
      this.onClear()
      var self = this
      RegulationWorkshopReturnRepository.GetByRegulationAutoID(this.regulation.id)
        .then((response) => {
          var result = response.data.data
          if (result) {
            Tools.SetValueInForm(self.form, self.data, result)
            this.STG_FRUSTRATED = (result.regulationAutoSchedulingStatus && result.regulationAutoSchedulingStatus.mnemonic === 'STG_FRUSTRATED')
            this.STG_CANCELED = (result.regulationAutoSchedulingStatus && result.regulationAutoSchedulingStatus.mnemonic === 'STG_CANCELED')
            if (result.autoModel) {
              self.setAutoType(result.autoModel.brand.autoTypeID)
                .then(func => self.changeAutoType(result.autoModel.brand.autoTypeID, func))
                .then(func => self.setBrand(result.autoModel.brandID, func))
                .then(func => self.changeBrand(result.autoModel.brandID, func))
                .then(func => self.setAuto(result.autoModel.id, func))
                .catch(function (err) {
                  console.log(err)
                })
            }
          }
        })
        .catch((err) => {
          this.onException(err)
        })
      self.form.regulationAutoID.value = this.regulation.id
    },
    onChangeAutoType () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllBrand(self.form.autoTypeID.value)
      }, 500)
    },
    onChangeBrand () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllAutoModel(self.form.brandID.value)
      }, 500)
    },
    onLoadAllAutoType () {
      loading.push()
      AutoTypeRepository.GetAll()
        .then((response) => {
          this.form.autoTypeID.options = this.onResultDropdown(response, true)
        })
        .catch((err) => {
          this.onException(err)
        })
      this.form.autoTypeID.value = null
    },
    onLoadAllBrand (typeID) {
      this.form.brandID.options = []
      this.form.autoModelID.options = []
      if (typeID) {
        loading.push()
        BrandRepository.GetAllByAutoTypeID(typeID)
          .then((response) => {
            this.form.brandID.options = this.onResultDropdown(response, true)
          })
          .catch((err) => {
            this.onException(err)
          })
        this.form.brandID.value = null
      }
    },
    onLoadAllAutoModel (brandID) {
      this.form.autoModelID.options = []
      if (brandID) {
        loading.push()
        AutoModelRepository.GetAllByBrandID(brandID)
          .then((response) => {
            this.form.autoModelID.options = this.onResultDropdown(response, true)
          })
          .catch((err) => {
            this.onException(err)
          })
        this.form.autoModelID.value = null
      }
    },
    onDeleteImage (id) {
      loading.push()
      RegulationImageRepository.Delete(id)
        .then((response) => {
          this.onResult(response)
          this.onGetImageByMnemonic()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      RegulationWorkshopReturnRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    downloadImages () {
      loading.push()
      if (this.regulation) {
        RegulationImageRepository.DownloadImages(this.regulation.id)
          .then((response) => {
            var file = response.data.data
            var base64 = 'data:' + file.contentType + ';base64,' + file.base64

            download(base64, file.alias, file.contentType)
            loading.pop()
          })
          .catch((err) => {
            this.onException(err)
            loading.pop()
          })
      } else {
        loading.pop()
      }
    },
    DownloadByImageType () {
      loading.push()
      if (this.images && this.images.length > 0) {
        RegulationImageRepository.DownloadImagesByImageType(this.regulation.id, this.ImageTypeMnemonic)
          .then((response) => {
            var file = response.data.data
            var base64 = 'data:' + file.contentType + ';base64,' + file.base64

            download(base64, file.name, file.contentType)
            loading.pop()
          })
          .catch((err) => {
            this.onException(err)
            loading.pop()
          })
      } else {
        toast.warning('Não há arquivos para download!')
        loading.pop()
      }
    },
    setBrand (brandID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.brandID.value = brandID
          resolve()
        }, 200)
      })
    },
    setAuto (autoModelID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.autoModelID.value = autoModelID
          resolve()
        }, 300)
      })
    },
    changeAutoType (autoTypeID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.brandID.options = []
          self.form.autoModelID.options = []
          loading.push()
          BrandRepository.GetAllByAutoTypeID(autoTypeID)
            .then((response) => {
              self.form.brandID.options = self.onResultDropdown(response, true)
            })
            .catch((err) => {
              self.onException(err)
            })
          resolve()
        }, 200)
      })
    },
    setAutoType (autoTypeID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.autoTypeID.value = autoTypeID
          resolve()
        }, 200)
      })
    },
    changeBrand (brandID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.autoModelID.options = []
          loading.push()
          AutoModelRepository.GetAllByBrandID(brandID)
            .then((response) => {
              self.form.autoModelID.options = self.onResultDropdown(response, true)
            })
            .catch((err) => {
              self.onException(err)
            })
          resolve()
        }, 800)
      })
    },
    addFiles () {
      this.$refs.files.click()
    },
    openModalSendImages () {
      this.$refs['modal-uploading-image'].show()
      this.variantProgressBar = 'primary'
    },
    closeModalSendImages () {
      this.$refs['modal-uploading-image'].hide()
      this.variantProgressBar = 'primary'
      this.qntImagensSend = 0
      this.qntImagensSendTotal = 0
      this.qntImagensReportSend = 0
    },
    atualizarPercentagemUploadImagem (qntSucesso, qntImagem) {
      this.qntImagensSend = Math.round((qntSucesso / qntImagem) * 100)
    },
    async compressImage (file, { quality = 1, type = file.type }) {
      const imageBitmap = await createImageBitmap(file)
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.width = imageBitmap.width / 2
      canvas.height = imageBitmap.height / 2
      ctx.drawImage(imageBitmap, 0, 0, canvas.width, canvas.height)
      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, type, quality)
      )
      return new File([blob], file.name, {
        type: blob.type
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/inspection/workshopreturn/sinisterworkshopreturn.js